export default __webpack_public_path__ + "static/img5-44a5a09b2d2ed6bfd71d2d00d42920df.png";